import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-contact-us',
  templateUrl: './new-contact-us.component.html',
  styleUrls: ['./new-contact-us.component.scss'],
      encapsulation: ViewEncapsulation.None,
  
})
export class NewContactUsComponent implements OnInit {

  public employee: any[] = [];
  public messages: any = {};

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,        private toastr : ToastrService , 
    private translate: TranslateService
  ) {} 
    public pages  : any

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;

  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

  ngOnInit(): void {
    this.apisService.contactUs().subscribe({ 
      next:(response:any)=> { 
        this.employee = response.data || [] ;
        console.log('response is' , this.employee)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })

     this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this.translate.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this.translate.instant('MENU.DASHBOARD.total')
    };
  }

   getTags(){ 
  this.apisService.contactUs().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
        this.employee = response.data || [] ;

      this.totalItems = this.employee.length;
      console.log("employee:", this.employee);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }
 



viewDetails(productId: number) {
  this.router.navigate(['/new-contact-us-details', productId]);
}


}